import { useParams } from "react-router-dom";
import { ISolicitudEvento } from "@/shared/interfaces";
import { useFetchGetByIdSolicitudEvento } from "@/shared/actions/erp/marketing/solicitudEvento.action";
import SaveSolicitudesEventoCanje from "../../shared/saveSolicitudesEventoCanje/SaveSolicitudesEventoCanje";

const EditSolicitudesEvento = ()=>{

  const {idsolicitud} = useParams()
  const { data:dataSolicitudEvento, isLoading:isLoadingSolicitudEvento } = useFetchGetByIdSolicitudEvento(idsolicitud!)

  if (isLoadingSolicitudEvento) return null 

  return(
    <SaveSolicitudesEventoCanje title="Editar Solicitud de Evento" dataSolicitud={dataSolicitudEvento?.data as ISolicitudEvento}/>
  )
}
export default EditSolicitudesEvento;